import SvgLate from "../../svg/SvgLate";
import SvgMoon from "../../svg/SvgMoon";
import SvgSun from "../../svg/SvgSun";

export default function SvgHorario({ typeSchedule }) {
    switch (typeSchedule) {
        case 'mañana':
            return <SvgSun />;
        case 'tarde':
            return <SvgLate />;
        case 'noche':
            return <SvgMoon />;
        default:
            return null; // o puedes devolver un ícono por defecto o un mensaje de error
    }
}

// dependiendo del tipo de valor que reciba mañana tarde noche me devuelve el svg correspondiente Esta estructura tiene que replicarse en todo el proyecto para poder reutilizar todo de una forma mucho mas facil
